import { palette } from '@dev/ee-components';
import styled from 'styled-components';

export const TitleWrapper = styled.div<{ $isSidebar?: boolean }>`
    width: 100%;
    max-width: ${({ $isSidebar }) => ($isSidebar ? '239px' : 'auto')};
    max-height: ${({ $isSidebar }) => ($isSidebar ? '98px' : 'auto')};
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 32px;
`;

export const UpsellingInfoWrapper = styled.div<{ $isSidebar?: boolean }>`
    width: fit-content;
    max-width: ${({ $isSidebar }) => ($isSidebar ? '287px' : 'auto')};
    margin: auto;
    background-color: ${palette.snow[2]};
    padding: 32px 24px;
    border: 1px solid #e6e9f2;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    margin-bottom: 24px;
    margin-top: 0;
`;

export const TitleLockIcon = styled.div`
    width: 19px;
    height: 19px;
    border-radius: 4px;
    background: ${palette.indigo[5]};
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const BodyWrapper = styled.div<{ $isSidebar?: boolean }>`
    width: 100%;
    max-width: ${({ $isSidebar }) => ($isSidebar ? '239px' : 'auto')};

    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-bottom: 24px;

    h3 {
        margin-bottom: 0;
    }
`;
